// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    margin: 0;
    padding: 0;
    max-width: 100%;
    overflow-x: hidden;
}
/* Navbar */
.menu-color {
    background-color: #f7f7f7;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.menu-container {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    justify-content: space-between;
}

.menu-content {
    display: flex;
    align-items: center;
    gap: 30px;
}

/* Botão de Logout */
.logout-button {
    background: none;
    border: none;
    color: #333;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 500;
    padding: 8px 12px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.logout-button:hover {
    background-color: #e0e0e0;
}

.logout-button span {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    letter-spacing: 0.5px;
}

/* Menu principal - Logo com zoom controlado */
.menu-logo {
    display: inline-block; /* Importante para o zoom */
}

.menu-logo img {
    width: 150px;
    height: auto;
    transition: transform 0.3s ease;
    transform-origin: left center; /* Ponto de origem do zoom */
    image-rendering: -webkit-optimize-contrast; /* Melhora a qualidade do zoom */
    image-rendering: crisp-edges;
}

/* Permite zoom com Ctrl+Scroll apenas na imagem */
.menu-logo img {
    touch-action: manipulation; /* Permite zoom programático */
}

/* Efeito visual opcional ao passar o mouse */
.menu-logo img:hover {
    transform: scale(1.05);
}

.menu-toggle {
    display: none;
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
    color: #333;
}

.center-menu {
    list-style: none;
    display: flex;
    gap: 20px;
    padding: 0;
    margin: 0;
}

.center-menu li a {
    text-decoration: none;
    color: #333;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 15px;
    transition: color 0.3s;
}

.center-menu li a:hover {
    color: #0066cc;
}

.margin-icon {
    margin-right: 0.3rem;
    color: #0066cc;
    font-size: 0.6rem;
}

/* Media Queries */
@media (max-width: 768px) {
    .menu-content {
        position: fixed;
        top: 60px;
        left: 0;
        width: 100%;
        background-color: #f7f7f7;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .menu-content.open {
        transform: translateX(0);
    }

    .center-menu {
        flex-direction: column;
        width: 100%;
        gap: 15px;
    }

    .logout-button {
        margin-top: 20px;
        padding-left: 0;
    }

    .menu-toggle {
        display: block;
    }
    
    /* Ajuste para mobile */
    .menu-logo img {
        width: 120px; /* Tamanho menor em mobile */
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menu/stylesMenu.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;AACA,WAAW;AACX;IACI,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,aAAa;IACb,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA,8CAA8C;AAC9C;IACI,qBAAqB,EAAE,2BAA2B;AACtD;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B,EAAE,4BAA4B;IAC3D,0CAA0C,EAAE,gCAAgC;IAC5E,4BAA4B;AAChC;;AAEA,kDAAkD;AAClD;IACI,0BAA0B,EAAE,8BAA8B;AAC9D;;AAEA,6CAA6C;AAC7C;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,WAAW;QACX,yBAAyB;QACzB,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,wCAAwC;QACxC,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA,uBAAuB;IACvB;QACI,YAAY,EAAE,4BAA4B;IAC9C;AACJ","sourcesContent":["html, body {\n    margin: 0;\n    padding: 0;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n/* Navbar */\n.menu-color {\n    background-color: #f7f7f7;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    width: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.menu-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    max-width: 1200px;\n    justify-content: space-between;\n}\n\n.menu-content {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n}\n\n/* Botão de Logout */\n.logout-button {\n    background: none;\n    border: none;\n    color: #333;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 15px;\n    font-weight: 500;\n    padding: 8px 12px;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.logout-button:hover {\n    background-color: #e0e0e0;\n}\n\n.logout-button span {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    letter-spacing: 0.5px;\n}\n\n/* Menu principal - Logo com zoom controlado */\n.menu-logo {\n    display: inline-block; /* Importante para o zoom */\n}\n\n.menu-logo img {\n    width: 150px;\n    height: auto;\n    transition: transform 0.3s ease;\n    transform-origin: left center; /* Ponto de origem do zoom */\n    image-rendering: -webkit-optimize-contrast; /* Melhora a qualidade do zoom */\n    image-rendering: crisp-edges;\n}\n\n/* Permite zoom com Ctrl+Scroll apenas na imagem */\n.menu-logo img {\n    touch-action: manipulation; /* Permite zoom programático */\n}\n\n/* Efeito visual opcional ao passar o mouse */\n.menu-logo img:hover {\n    transform: scale(1.05);\n}\n\n.menu-toggle {\n    display: none;\n    font-size: 24px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #333;\n}\n\n.center-menu {\n    list-style: none;\n    display: flex;\n    gap: 20px;\n    padding: 0;\n    margin: 0;\n}\n\n.center-menu li a {\n    text-decoration: none;\n    color: #333;\n    font-size: 15px;\n    font-weight: 500;\n    padding: 10px 15px;\n    transition: color 0.3s;\n}\n\n.center-menu li a:hover {\n    color: #0066cc;\n}\n\n.margin-icon {\n    margin-right: 0.3rem;\n    color: #0066cc;\n    font-size: 0.6rem;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n    .menu-content {\n        position: fixed;\n        top: 60px;\n        left: 0;\n        width: 100%;\n        background-color: #f7f7f7;\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 20px;\n        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n        transform: translateX(-100%);\n        transition: transform 0.3s ease;\n    }\n\n    .menu-content.open {\n        transform: translateX(0);\n    }\n\n    .center-menu {\n        flex-direction: column;\n        width: 100%;\n        gap: 15px;\n    }\n\n    .logout-button {\n        margin-top: 20px;\n        padding-left: 0;\n    }\n\n    .menu-toggle {\n        display: block;\n    }\n    \n    /* Ajuste para mobile */\n    .menu-logo img {\n        width: 120px; /* Tamanho menor em mobile */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
